import { HttpRequestMethodTypes, JSON_CONTENT_TYPE_HEADER } from 'types';
import { fetchWithRetry } from 'utils/fetchWithRetry';
import { FetchOptions } from 'types/fetchWithRetry';

import type { ConsentRequestBodyType } from './types';

const USER_FACING_CONSENT_ERROR = 'Unable to save your consent. Please try again.';

export default async function captureFubUserWithConsent(body: ConsentRequestBodyType) {
  const options: FetchOptions = { 
    headers: JSON_CONTENT_TYPE_HEADER, 
    method: HttpRequestMethodTypes.POST,
    body: JSON.stringify(body),
  };

  let response: Response;
  try {
    response = await fetchWithRetry('/api/consent-disclaimers/handler', options);
  } catch {
    throw new Error(USER_FACING_CONSENT_ERROR);
  }

  const parsedResponse = await response.json();

  if (response.ok) {
    return parsedResponse;
  }

  throw new Error(USER_FACING_CONSENT_ERROR);
}
